import Vue from "vue";

import "./styles/quasar.scss";
import iconSet from "quasar/icon-set/mdi-v4.js";
import "@quasar/extras/roboto-font/roboto-font.css";
import "@quasar/extras/material-icons/material-icons.css";
import "@quasar/extras/fontawesome-v5/fontawesome-v5.css";
import "@quasar/extras/ionicons-v4/ionicons-v4.css";
import "@quasar/extras/mdi-v4/mdi-v4.css";
import "@quasar/extras/animate/fadeIn.css";
import "@quasar/extras/animate/fadeOut.css";

import Quasar from 'quasar/src/vue-plugin.js';import Notify from 'quasar/src/plugins/Notify.js';import AppFullscreen from 'quasar/src/plugins/AppFullscreen.js';import Dialog from 'quasar/src/plugins/Dialog.js';;

Vue.use(Quasar, {
  config: {
    notify: {
      position: "top-right",
      timeout: 2500,
      progress: true,
      actions: [{ icon: "close", color: "white" }]
    }
  },
  plugins: {
    Notify,
    AppFullscreen,
    Dialog
  },
  iconSet: iconSet
});

Notify.registerType("refresh", {
  position: "top-right",
  timeout: 2500,
  progress: true
});
